import { render } from "./CalendarHour.vue?vue&type=template&id=22c2bbc8"
import script from "./CalendarHour.vue?vue&type=script&lang=js"
export * from "./CalendarHour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__